/*
  tabLOVAS — ürün kartında görsel kaydırma (mobil + tablet, <= 991px)
  12 Ağustos 2026

  Ne yapar:
  1) Kart görseline ilk dokunulduğunda ertelenmiş slaytların src/srcset'ini açar.
     Sayfa ilk yüklenirken bu görseller İNMEZ — mobil veri ve LCP korunur.
  2) Kaydırdıkça alttaki noktaları günceller.
  3) Kaydırma hareketini tıklamadan ayırır: parmak 10px'den fazla yatay
     kaydıysa <a> linki tetiklenmez, yanlışlıkla ürün sayfasına girilmez.

  Bağımlılık yok, kütüphane yok. Ray = .media[data-lovas-galeri]

  GERİ ALMA: bu dosyayı sil + theme.liquid'deki script satırını kaldır.
*/
(function () {
  'use strict';

  function kapsayan(hedef, secici) {
    if (!hedef || hedef.nodeType !== 1 || !hedef.closest) return null;
    return hedef.closest(secici);
  }

  /* Masaüstünde fazladan slaytlar CSS ile gizli — orada indirmenin anlamı yok. */
  function kaydirmaAcikMi() {
    return window.matchMedia('(max-width: 991px)').matches;
  }

  /* Ertelenmiş slaytları yükle — kart başına yalnızca bir kez çalışır. */
  function slaytlariYukle(ray) {
    if (ray.dataset.lovasYuklu === '1') return;
    if (!kaydirmaAcikMi()) return;
    ray.dataset.lovasYuklu = '1';
    var bekleyen = ray.querySelectorAll('img[data-src]');
    for (var i = 0; i < bekleyen.length; i++) {
      var im = bekleyen[i];
      if (im.getAttribute('data-srcset')) im.srcset = im.getAttribute('data-srcset');
      im.src = im.getAttribute('data-src');
      im.removeAttribute('data-src');
      im.removeAttribute('data-srcset');
    }
  }

  function noktalariGuncelle(ray) {
    var sarmal = ray.parentElement;
    if (!sarmal) return;
    var kutu = sarmal.querySelector('[data-lovas-noktalar]');
    if (!kutu || !ray.clientWidth) return;
    var aktif = Math.round(ray.scrollLeft / ray.clientWidth);
    var noktalar = kutu.children;
    for (var i = 0; i < noktalar.length; i++) {
      noktalar[i].classList.toggle('lovas-nokta--aktif', i === aktif);
    }
  }

  /* --- dokunma: yükle + kaydırma/tıklama ayrımı için başlangıcı işaretle --- */
  var basX = 0;
  var basY = 0;
  var kaydirildi = false;

  document.addEventListener(
    'pointerdown',
    function (e) {
      basX = e.clientX;
      basY = e.clientY;
      kaydirildi = false;
      var ray = kapsayan(e.target, '[data-lovas-galeri]');
      if (ray) slaytlariYukle(ray);
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'pointermove',
    function (e) {
      if (kaydirildi) return;
      var dx = Math.abs(e.clientX - basX);
      var dy = Math.abs(e.clientY - basY);
      if (dx > 10 && dx > dy) kaydirildi = true;
    },
    { passive: true, capture: true }
  );

  /* Yatay kaydırma olduysa kartın linkini iptal et. capture: true —
     temanın kendi tıklama dinleyicilerinden önce çalışması gerekiyor. */
  document.addEventListener(
    'click',
    function (e) {
      if (!kaydirildi) return;
      var link = kapsayan(e.target, '.product__media_thumbnail');
      if (link) {
        e.preventDefault();
        e.stopPropagation();
      }
      kaydirildi = false;
    },
    true
  );

  /* --- kaydırma: noktaları güncelle (scroll balonlanmaz, capture ile yakalanır) --- */
  document.addEventListener(
    'scroll',
    function (e) {
      var ray = e.target;
      if (!ray || ray.nodeType !== 1 || !ray.hasAttribute) return;
      if (!ray.hasAttribute('data-lovas-galeri')) return;
      slaytlariYukle(ray);
      if (ray.lovasRafBekliyor) return;
      ray.lovasRafBekliyor = true;
      window.requestAnimationFrame(function () {
        ray.lovasRafBekliyor = false;
        noktalariGuncelle(ray);
      });
    },
    true
  );

  /* --- Karusel içindeki kartlarda galeriyi tamamen kapat (13 Ağustos 2026) ---
     Ana sayfadaki "Kanvas Tablolar" bölümü yatay bir karusel (.swiper-wrapper).
     Kartın içine ikinci bir yatay kaydırma koyunca iki jest çakışıyor ve
     kullanıcı görselleri kaydıramıyor bile — parmak hareketini karusel yutuyor.
     Zaten orada gerek de yok: bölümün kendisi zaten kaydırılarak geziliyor.

     Çözüm CSS ile değil JS ile: sınıfı ve fazladan slaytları DOM'dan kaldırıyoruz.
     Böylece kart temanın orijinal hâline (ana görsel + hover görseli) dönüyor,
     CSS özgüllük savaşı yaşanmıyor. Slaytlarda src yok, yani indirme de olmuyor. */
  function karuselIcindeKapat() {
    var raylar = document.querySelectorAll("[data-lovas-galeri]");
    for (var i = 0; i < raylar.length; i++) {
      var ray = raylar[i];
      if (!ray.closest) continue;
      if (!ray.closest(".swiper, .swiper-wrapper, .swiper-slide")) continue;

      ray.classList.remove("lovas-kaydirilabilir");
      ray.removeAttribute("data-lovas-galeri");

      var ek = ray.querySelectorAll("img.lovas-ek-slayt");
      for (var j = 0; j < ek.length; j++) ek[j].parentNode.removeChild(ek[j]);

      var kap = ray.parentElement;
      var nokta = kap && kap.querySelector("[data-lovas-noktalar]");
      if (nokta) nokta.parentNode.removeChild(nokta);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", karuselIcindeKapat);
  } else {
    karuselIcindeKapat();
  }
  /* Karusel eklentisi kartları sonradan taşıyabiliyor — ikinci tur. */
  window.addEventListener("load", karuselIcindeKapat);
})();
